import React, { useState } from "react";

import { useDispatch } from "react-redux";

import { Button } from "reactstrap";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Popover from "@mui/material/Popover";
import { addContractData } from "../../store/actions/contract";
import { addMasterContractData } from "../../store/actions/admin";

const EditPopup = (props) => {
    const dispatch = useDispatch();
    const { anchorEl, setAnchorEl, contractId } = props;
    const [textValue, setTextValue] = useState("");

    const handleCloseEdit = () => {
        setTextValue("");
        setAnchorEl(null);
    };
    const handleChangeText = (event) => {
        const { value } = event.target;
        setTextValue(value);
    };
    const handleSubmit = () => {
        let data = {
            customName:
                anchorEl?.id === "edit-name"
                    ? textValue
                    : anchorEl?.id === "master-edit-name"
                    ? textValue
                    : "",
            customDescription:
                anchorEl?.id === "edit-description"
                    ? textValue
                    : anchorEl?.id === "master-edit-description"
                    ? textValue
                    : "",
        };
        if (
            anchorEl?.id === "edit-name" ||
            anchorEl?.id === "edit-description"
        ) {
            dispatch(addContractData(contractId, data));
        }
        if (
            anchorEl?.id === "master-edit-name" ||
            anchorEl?.id === "master-edit-description"
        ) {
            dispatch(addMasterContractData(contractId, data));
        }
        handleCloseEdit();
    };

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleCloseEdit}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "center",
            }}
        >
            <Box
                sx={{
                    width: "350px",
                    display: "flex",
                    flexWrap: "nowrap",
                    gap: "0.5rem",
                    p: "1rem",
                }}
            >
                <TextField
                    sx={{ width: "85%" }}
                    variant="standard"
                    value={textValue}
                    onChange={handleChangeText}
                />
                <Button color="primary" onClick={handleSubmit}>
                    Submit
                </Button>
            </Box>
        </Popover>
    );
};

export default EditPopup;
